(function () {
  const productGrid = document.querySelector('[data-product-grid], .product-grid, #product-grid, ul.grid');
  const paginationEl = document.querySelector('.pagination, nav[role="navigation"]');

  if (!productGrid || !paginationEl) return;

let nextPageUrl = paginationEl.querySelector('a[aria-label*="next" i], a[aria-label*="Next" i]')?.href;

  if (!nextPageUrl) {
    paginationEl.style.display = 'none';
    return;
  }

  // Hide default pagination
  paginationEl.style.display = 'none';

  // Loading spinner
  const loader = document.createElement('div');
  loader.id = 'infinite-scroll-loader';
  loader.innerHTML = '<p style="text-align:center;padding:2rem;">Loading...</p>';
  loader.style.display = 'none';
  productGrid.parentNode.insertBefore(loader, paginationEl);

  let loading = false;

  const observer = new IntersectionObserver((entries) => {
    if (entries[0].isIntersecting && !loading && nextPageUrl) {
      loading = true;
      loader.style.display = 'block';

      fetch(nextPageUrl)
        .then(res => res.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newProducts = doc.querySelectorAll('[data-product-grid] > *, .product-grid > *, #product-grid > *, ul.grid > li');
          
          newProducts.forEach(item => productGrid.appendChild(item));

          const newPagination = doc.querySelector('.pagination a[aria-label*="next" i], nav[role="navigation"] a[aria-label*="next" i]');


          loader.style.display = 'none';
          loading = false;

          if (!nextPageUrl) observer.disconnect();
        })
        .catch(() => {
          loader.style.display = 'none';
          loading = false;
        });
    }
  }, { rootMargin: '200px' });

  observer.observe(loader);
})();
